module.exports = __webpack_public_path__ + "static/media/air_condition.a63d4b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/air_condition.svg
// module id = 524
// module chunks = 0